import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
import { getMessaging, isSupported } from 'firebase/messaging';

const env = (k, fallback) => {
  const v = process.env[k];
  return v != null && String(v).trim() !== '' ? v : fallback;
};

const firebaseConfig = {
  apiKey: env('REACT_APP_FIREBASE_API_KEY', 'AIzaSyC5xHYEqr_YaavjXP1pkktqs0nEBBvkQh8'),
  authDomain: env('REACT_APP_FIREBASE_AUTH_DOMAIN', 'haydi-80cab.firebaseapp.com'),
  projectId: env('REACT_APP_FIREBASE_PROJECT_ID', 'haydi-80cab'),
  storageBucket: env('REACT_APP_FIREBASE_STORAGE_BUCKET', 'haydi-80cab.firebasestorage.app'),
  messagingSenderId: env('REACT_APP_FIREBASE_MESSAGING_SENDER_ID', '919848044249'),
  appId: env('REACT_APP_FIREBASE_APP_ID', '1:919848044249:web:f93f8c0688614ae4ab60c8'),
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');
export const storage = getStorage(app);
export { app };

let messagingPromise;
/** Resolves to `Messaging` or `null` if unsupported (e.g. Safari without push). */
export function getFirebaseMessaging() {
  if (!messagingPromise) {
    messagingPromise = isSupported()
      .then((supported) => (supported ? getMessaging(app) : null))
      .catch(() => null);
  }
  return messagingPromise;
}

export { getDownloadURL, ref, uploadBytes } from 'firebase/storage';

/** Import these from here (not directly from 'firebase/firestore') so `db` and `collection()` share one SDK instance — avoids instanceof / duplicate-bundle runtime errors. */
export {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  limit,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  setDoc,
  Timestamp,
  updateDoc,
  arrayUnion,
  where,
} from 'firebase/firestore';
